import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import AppLogo from "../common/appLogo";

interface props {
  title?: string;
  activeQustionNumber?: any;
  setActiveQuestionNumber?: any;
  roadType?: string;
}

const QuestionRoadblock: React.FC<props> = (props) => {
  const { roadType } = props;
  return (
    <>
      {roadType == "entry" ? (
        <div className="entry-page">
          <div className="content">
            <h1>
              Take out your current skin care products.<br />
              It's time to check— <span className="bold">Keep Using</span> or <span className="bold">Do Not Use</span>
            </h1>
            <Button
              htmlType="submit"
              className="btn-primary ready-btn"
              onClick={() => {
                props.setActiveQuestionNumber(props.activeQustionNumber + 1);
              }}
            >
              I'm Ready to Personalize!
            </Button>
          </div>
          <div className="footer">
            <AppLogo color="#6489b1" />
          </div>
        </div>
      ) : (
        <div className="question-roadblock">
          <h2>{props?.title}</h2>
          <Button
            className="btn-primary proceed-btn"
            onClick={() => {
              props.setActiveQuestionNumber(props.activeQustionNumber + 1);
            }}
          >
            Let's go
            <ArrowRightOutlined />
          </Button>
        </div>
      )}
    </>
  );
};

export default QuestionRoadblock;
